(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationstatusController', ApplicationstatusController);

    ApplicationstatusController.$inject = ['Applicationstatus'];

    function ApplicationstatusController(Applicationstatus) {

        var vm = this;

        vm.applicationstatuses = [];

        loadAll();

        function loadAll() {
            Applicationstatus.query(function(result) {
                vm.applicationstatuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();
